import React from 'react';
import { AlertOctagon, DollarSign, EyeOff } from 'lucide-react';

const Hero = () => {
    return (
        <>
            <section
                className="relative lg:min-h-screen flex flex-col justify-center section-padding-hero overflow-hidden bg-accent-light">
                <div
                    className="absolute inset-y-0 right-0 w-1/2 bg-accent/5 rounded-l-full transform translate-x-1/3 -translate-y-1/4 blur-3xl">
                </div>
                <div
                    className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-secondary/5 rounded-r-full transform -translate-x-1/4 translate-y-1/4 blur-3xl">
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center max-w-4xl mx-auto">
                        <h1 className="heading-xl mb-6" data-aos="fade-up">
                            Revenue Cycle Management Built by Clinicians,
                            for Clinicians
                        </h1>
                        <p className="paragraph-lg max-w-2xl mx-auto mb-10" data-aos="fade-up" data-aos-delay="100">
                            We care for your financial integrity as deeply as you care for your patients. Replace "black-box"
                            billing with radical, real-time visibility.
                        </p>
                        <div className="mt-8 flex justify-center gap-4 flex-col sm:flex-row" data-aos="fade-up" data-aos-delay="200">
                            <a href="#contact" className="btn-primary-lg">
                                Reclaim Your Revenue
                            </a>
                            <a href="#dashboard" className="btn-secondary-lg">
                                Explore Platform
                            </a>
                        </div>
                    </div>

                </div>
            </section>

            <section className="relative py-20 bg-primary lg:pb-32">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-5xl mx-auto">
                        <div className="bg-motion-dark rounded-[3rem] p-12 md:p-16 lg:p-20 text-center relative overflow-hidden">

                            <div className="relative z-10">
                                <p className="label-md text-accent mb-4 uppercase tracking-widest">Problem</p>
                                <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-white mb-16 tracking-tight">
                                    The true cost of compounding complexity
                                </h2>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
                                    <div data-aos="zoom-in" data-aos-delay="300">
                                        <AlertOctagon className="w-8 h-8 text-accent mb-6 mx-auto" strokeWidth="1" />
                                        <p className="heading-md !text-white !font-sans mb-3 mx-auto">Double-digit</p>
                                        <p className="paragraph-md text-white/70 max-w-[200px] mx-auto">
                                            Denial rates your biller isn't surfacing.
                                        </p>
                                    </div>
                                    <div data-aos="zoom-in" data-aos-delay="400">
                                        <DollarSign className="w-8 h-8 text-accent mb-6 mx-auto" strokeWidth="1" />
                                        <p className="heading-md !text-white !font-sans mb-3 mx-auto">Millions</p>
                                        <p className="paragraph-md text-white/70 max-w-[200px] mx-auto">
                                            In recoverable revenue quietly walking out the door.
                                        </p>
                                    </div>
                                    <div data-aos="zoom-in" data-aos-delay="500">
                                        <EyeOff className="w-8 h-8 text-accent mb-6 mx-auto" strokeWidth="1" />
                                        <p className="heading-md !text-white !font-sans mb-3 mx-auto">Zero visibility</p>
                                        <p className="paragraph-md text-white/70 max-w-[200px] mx-auto">
                                            Into claim status until you go looking for it.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Hero;
